import React, { Ref, forwardRef } from 'react'
import ListItem from '@mui/material/ListItem'
import { NavLink, NavLinkProps } from 'react-router-dom'

interface TopBarListItemProps {
  className?: string
  link?: string
  onClick: () => void
}

export const TopBarListItem: React.FC<TopBarListItemProps> = props => {
  const { className, link, children, onClick, ...rest } = props

  if (link)
    return (
      <ListItem
        button
        className={className}
        // there's probably a better way to do this, but during mui4 -> 5 migration we didn't want to make any functional changes
        component={
          forwardRef((props: NavLinkProps, ref: Ref<HTMLAnchorElement>) => (
            <NavLink ref={ref} exact {...props} to={link ?? ''} activeClassName='active' />
          )) as any
        }
        onClick={onClick}
        {...rest}
      >
        {children}
      </ListItem>
    )

  return (
    <ListItem button className={className} onClick={onClick} {...rest}>
      {children}
    </ListItem>
  )
}
